import { FC } from 'react';
import { Button } from 'primereact/button';
import { FileChartColumn, FileCode, FileText, File } from 'lucide-react';
import { downloadFile, downloadOriginalFile } from '@/api/services/File';

interface ExportButtonsProps {
  fileId: string;
  isDisabled: boolean;
}

const ExportButtons: FC<ExportButtonsProps> = ({ fileId, isDisabled }) => {
  return (
    <div className={'flex gap-1 items-center'}>
      <Button
        icon={<FileChartColumn size={22} />}
        text={true}
        severity={'success'}
        tooltip={'.xlsx'}
        tooltipOptions={{ position: 'top' }}
        onClick={() => downloadFile(fileId, 'xlsx')}
        className={'focus:shadow-none'}
        disabled={isDisabled}
      />
      <Button
        icon={<FileCode size={22} />}
        text={true}
        severity={'warning'}
        tooltip={'.ini'}
        tooltipOptions={{ position: 'top' }}
        onClick={() => downloadFile(fileId, 'ini')}
        className={'focus:shadow-none'}
        disabled={isDisabled}
      />
      <Button
        icon={<FileText size={22} />}
        text={true}
        severity={'warning'}
        tooltip={'.pdf'}
        tooltipOptions={{ position: 'top' }}
        onClick={() => downloadFile(fileId, 'pdf')}
        className={'focus:shadow-none'}
        disabled={isDisabled}
      />
      <Button
        icon={<File size={22} />}
        text={true}
        severity={'help'}
        tooltip={'Původní .pdf'}
        tooltipOptions={{ position: 'top' }}
        onClick={() => downloadOriginalFile(fileId)}
        className={'focus:shadow-none'}
        disabled={isDisabled}
      />
    </div>
  );
};

export default ExportButtons;
